// import { faRupiahSign } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import PramodPathak from '../../img/PramodPathak.jpg'
import RahulMishra from '../../img/RahulMishra.jpeg'



const BusinessAdvisor = () => {
    return (
        <div className='px-4 md:px-12 md:mt-20 mt-8 mb-8'>
            <h1 className='md:text-5xl text-2xl font-semibold text-center'>Business <span className='text-orange-400'>Advisor/Investor</span></h1>
            <div className='grid grid-cols-1 md:grid-cols-2 md:gap-8 gap-4 mt-4 md:mt-8'>
                <div>
                    <img className='mx-auto rounded-full w-52' src={PramodPathak} alt="" />
                    <h4 className='text-center text-xl font-semibold'>Pramod Pathak</h4>
                    <p className='text-center text-sm'>Business Advisor</p>
                    
                    </div>
                <div>
                <img className='mx-auto rounded-full w-52' src={RahulMishra} alt="" />
                <h4 className='text-center text-xl font-semibold'>Rahul Mishra</h4>
                    <p className='text-center text-sm'>Angel Investor</p>
                
                </div>
            </div>
        </div>
    );
};

export default BusinessAdvisor;